module.exports = __webpack_public_path__ + "img/yishanchu.ae4bcca2.png";